/*! cart.html — rendu page panier (localStorage) */
(function(){"use strict";function _e(s){return String(s==null?"":s).replace(/[<>"'&]/g,function(c){return({'<':"&lt;","&":"&amp;",">":"&gt;","\"":"&quot;","'":"&#39;"})[c]})};
  const Y="atomgym_cart_v1",I="atomgym_promo_v1";
  const getCart=()=>{try{return JSON.parse(localStorage.getItem(Y))||[]}catch{return[]}};
  const setCart=t=>localStorage.setItem(Y,JSON.stringify(t));
  const fmt=t=>t.toFixed(2).replace(".",",")+" €";

  function resetPromo(){
    localStorage.removeItem(I);
    const h=document.getElementById("cart-promo-input");
    const r=document.getElementById("cart-promo-msg");
    const C=document.getElementById("cart-promo-row");
    if(h) h.value="";
    if(r){r.textContent="";r.className="cart-promo-msg"}
    if(C) C.style.display="none";
  }

  function render(){
    const t=getCart();
    const a=document.getElementById("cart-page-list");
    const e=document.getElementById("cart-page-empty");
    const n=localStorage.getItem(I)||"";
    const d=document.getElementById("cart-subtotal");
    const ship=document.getElementById("cart-shipping");
    const C=document.getElementById("cart-promo-row");
    const x=document.getElementById("cart-promo-amt");
    const b=document.getElementById("cart-total");
    const m=document.getElementById("cart-checkout-btn");

    if(t.length===0){
      e.style.display="";
      a.style.display="none";
      if(m){m.style.pointerEvents="none";m.style.opacity=".5"}
      d.textContent=fmt(0);
      ship.textContent="—";
      b.textContent=fmt(0);
      resetPromo();
      return;
    }

    e.style.display="none";
    a.style.display="";
    if(m){m.style.pointerEvents="";m.style.opacity="1"}

    a.innerHTML=t.map((o,g)=>`
      <div class="cart-item" data-idx="${g}">
        <div class="cart-item-img"><img src="${_e(o.img||"/assets/logo.webp")}" alt="" width="90" height="112" loading="lazy"></div>
        <div class="cart-item-info">
          <div class="name">${_e(o.name)}</div>
          <div class="meta">Taille ${_e(o.size||"S")} \xB7 ${fmt(o.price||0)}</div>
          <div class="qty">
            <button type="button" data-action="minus" aria-label="Diminuer">−</button>
            <input type="text" inputmode="numeric" value="${Number(o.qty)||1}" aria-label="Quantit\xE9">
            <button type="button" data-action="plus" aria-label="Augmenter">+</button>
          </div>
        </div>
        <div class="cart-item-actions">
          <span class="cart-item-price">${fmt((Number(o.qty)||1)*(Number(o.price)||0))}</span>
          <button type="button" class="cart-item-remove" data-remove>Retirer</button>
        </div>
      </div>`).join("");

    const p=t.reduce((o,g)=>o+(g.qty||1)*(g.price||0),0);
    /* Livraison : Tom a demandé (19/05/2026) de RETIRER toute mention de prix livraison fixe. Calcul réel au checkout Shopify selon adresse. */
    let u=0;
    if(d) d.textContent=fmt(p);
    if(ship) ship.textContent="Calculée à l'étape suivante";
    if(b) b.textContent=fmt(Math.max(0,p-u));
    if(C){ if(u>0){C.style.display="";if(x) x.textContent="− "+fmt(u)}else{C.style.display="none"} }
  }

  document.addEventListener("click",t=>{
    const a=t.target.closest(".cart-item");
    if(!a) return;
    const e=parseInt(a.dataset.idx,10);
    const n=getCart();
    if(!n[e]){ render(); return; }
    if(t.target.matches("[data-remove]")){
      n.splice(e,1);setCart(n);render();
      document.dispatchEvent(new CustomEvent("atomgym:cart-changed"));
      return;
    }
    if(t.target.matches('[data-action="minus"]')){
      if(n[e].qty>1) n[e].qty--;
      setCart(n);render();
      document.dispatchEvent(new CustomEvent("atomgym:cart-changed"));
      return;
    }
    if(t.target.matches('[data-action="plus"]')){
      n[e].qty=(n[e].qty||1)+1;
      setCart(n);render();
      document.dispatchEvent(new CustomEvent("atomgym:cart-changed"));
      return;
    }
  });

  document.addEventListener("change",t=>{
    if(!t.target.matches(".cart-item .qty input")) return;
    const a=t.target.closest(".cart-item");
    const e=parseInt(a.dataset.idx,10);
    const n=Math.max(1,parseInt(t.target.value,10)||1);
    const d=getCart();
    if(!d[e]){ render(); return; }
    d[e].qty=n;setCart(d);render();
    document.dispatchEvent(new CustomEvent("atomgym:cart-changed"));
  });

  const f=document.getElementById("cart-promo-form");
  const h=document.getElementById("cart-promo-input");
  const r=document.getElementById("cart-promo-msg");

  if(f){
    const t=localStorage.getItem(I);
    if(t){
      h.value=t;
      r.textContent="Code \xAB "+t+" \xBB appliqu\xE9 (-10%)";
      r.className="cart-promo-msg ok";
    }

    f.addEventListener("submit",a=>{
      a.preventDefault();
      const e=(h.value||"").trim().toUpperCase();
      if(e==="ATOM10"){
        localStorage.setItem(I,e);
        r.textContent="Code \xAB ATOM10 \xBB appliqu\xE9 (-10% sur ta commande)";
        r.className="cart-promo-msg ok";
      } else if(e){
        localStorage.removeItem(I);
        r.textContent="Code \xAB "+e+" \xBB non reconnu. Essaie ATOM10.";
        r.className="cart-promo-msg err";
      } else {
        resetPromo();
      }
      render();
    });

    if(h){
      h.addEventListener("input",()=>{
        if((h.value||"").trim()===""){
          localStorage.removeItem(I);
          if(r){r.textContent="";r.className="cart-promo-msg"}
          render();
        }
      });
    }
  }

  window.addEventListener("storage",t=>{
    if(t.key===Y||t.key===I) render();
  });
  // Sync drawer ↔ cart page dans le même onglet (Karim 21/05 17:00)
  document.addEventListener("atomgym:cart-changed",render);

  render();
})();
